<template>
    <b-modal
        centered
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        v-model="form.show"
    >
        <template #modal-header="{}">
            <div class="header flex-grow-1 text-center">
                <h2 class="font-weight-bold">เพิ่มสินค้า</h2>
            </div>
            <span class="close cursor-pointer" @click="form.show = false">&times;</span>
        </template>
        <card shadow type="secondary" class="m--4">
            <b-row>
                <b-col cols="4">
                    <UploadImage :imageFile="form.item.image"/>
                </b-col>
                <b-col cols="8">
                    <b-row>
                        <b-col cols="6">
                            <b-form-group label="ชื่อสินค้า">
                                <b-form-input
                                    placeholder="ชื่อสินค้า"
                                    v-model="form.item.name"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="ประเภท">
                                <b-form-select
                                    :options="[]"
                                    v-model="form.item.type"
                                >
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="รายละเอียด">
                                <b-form-input
                                    placeholder="รายละเอียด"
                                    v-model="form.item.details"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="ราคา">
                                <b-form-input
                                    placeholder="ราคา"
                                    v-model="form.item.price"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="น้ำหนัก (กรัม)">
                                <b-form-input
                                    placeholder="น้ำหนัก"
                                    v-model="form.item.weight"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label="ขนาดสินค้า">
                                <div class="row">
                                    <div class="col boxs">
                                        <input
                                            v-model="form.item.dimension.width"
                                            type="number"
                                            min="1"
                                            placeholder="กว้าง"
                                            class="form-control"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                        />
                                    </div>
                                    <div class="col boxs">
                                        <input
                                            v-model="form.item.dimension.lenght"
                                            type="number"
                                            min="1"
                                            placeholder="ยาว"
                                            class="form-control"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                        />
                                    </div>
                                    <div class="col">
                                        <input
                                            v-model="form.item.dimension.height"
                                            type="number"
                                            min="1"
                                            placeholder="สูง"
                                            class="form-control"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                        />
                                    </div>
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <template slot="footer">
                <b-row class="justify-content-between">
                    <b-col cols="4">
                        <b-button
                            block
                            @click="closeModalConfirm()"
                        >
                            ยกเลิก
                        </b-button>
                    </b-col>
                    <b-col cols="4">
                        <b-button 
                            type="submit" 
                            variant="primary"
                            block
                            :disabled="form.isLoad"
                        >
                            <i class="fas fa-circle-notch fa-spin" v-if="form.isLoad"></i> 
                            ยืนยัน
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </card>
    </b-modal>
</template>
<script>
import UploadImage from '@/components/Common/UploadImage.vue'

export default {
    components: {
        UploadImage
    },
    props: {
        form: {
            type: Object
        }
    },
    methods: {
        closeModalConfirm(){
            this.form.show = false
            this.form.isLoad = false
            this.form.item = {
                name: null,
                details: null,
                type: null,
                weight: null,
                price: null,
                dimension: {
                    width: null,
                    lenght: null,
                    height: null
                },
                image: {
                    file: null,
                    preview: null
                }
            }
        }
    }
}
</script>
